import React from 'react';
import './intro-section-styles.css';
import 'animate.css/animate.min.css';
import { Link } from 'react-router-dom';
export const IntroSection = ({ navigation }) => {
  return (
    <div className='intro-container d-block d-lg-flex'>
      <div className='left-container'>
        <div className=''>
          <img className='logo' src={require('../../assets/app-logo.png')} />
          {/* <span className='app-name'>Reid Health</span> */}
        </div>
        <h1 className='heading head-font'>
          Welcome to Our<span className='text-theme head-font'> Lunch and Learn</span>{' '}
          Series
        </h1>
        <h4 className=' intro-sub-title my-4'>
          We are excited to announce the launch of a new series of lunch and
          learn sessions.
        </h4>
        <p className='description'>
          These sessions are designed to enhance our work experience, improve
          our processes, and leverage technology to drive innovation and
          excellence.
        </p>
        <ul className='intro-styled-list'>
          <li>Enhance ur work experience</li>
          <li>Improve ur processes </li>
          <li>Leverage Technology </li>
        </ul>
      </div>
      <div className='right-container'>
        <ul class='glass-card'>
          <li>
            <span className='icon-wrapper'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                height={30}
                fill='none'
                viewBox='0 0 24 24'
                stroke-width='1'
                stroke='currentColor'
                class='size-6'
              >
                <path
                  stroke-linecap='round'
                  stroke-linejoin='round'
                  d='M2.25 18 9 11.25l4.306 4.306a11.95 11.95 0 0 1 5.814-5.518l2.74-1.22m0 0-5.94-2.281m5.94 2.28-2.28 5.941'
                />
              </svg>
            </span>
            Enhance Our Work Experience
          </li>
          <li>
            <span className='icon-wrapper'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                height={30}
                fill='none'
                viewBox='0 0 24 24'
                stroke-width='1'
                stroke='currentColor'
                class='size-6'
              >
                <path
                  stroke-linecap='round'
                  stroke-linejoin='round'
                  d='M4.5 12a7.5 7.5 0 0 0 15 0m-15 0a7.5 7.5 0 1 1 15 0m-15 0H3m16.5 0H21m-1.5 0H12m-8.457 3.077 1.41-.513m14.095-5.13 1.41-.513M5.106 17.785l1.15-.964m11.49-9.642 1.149-.964M7.501 19.795l.75-1.3m7.5-12.99.75-1.3m-6.063 16.658.26-1.477m2.605-14.772.26-1.477m0 17.726-.26-1.477M10.698 4.614l-.26-1.477M16.5 19.794l-.75-1.299M7.5 4.205 12 12m6.894 5.785-1.149-.964M6.256 7.178l-1.15-.964m15.352 8.864-1.41-.513M4.954 9.435l-1.41-.514M12.002 12l-3.75 6.495'
                />
              </svg>
            </span>
            Improve Our Processes{' '}
          </li>
          <li>
            <span className='icon-wrapper'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                height={30}
                fill='none'
                viewBox='0 0 24 24'
                stroke-width='1'
                stroke='currentColor'
                class='size-6'
              >
                <path
                  stroke-linecap='round'
                  stroke-linejoin='round'
                  d='M15.042 21.672 13.684 16.6m0 0-2.51 2.225.569-9.47 5.227 7.917-3.286-.672ZM12 2.25V4.5m5.834.166-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243-1.59-1.59'
                />
              </svg>
            </span>
            Leverage Technology{' '}
          </li>
        </ul>
        <img
          className='intro-image d-none d-lg-block'
          src={require('../../assets/intro-image.jpg')}
        />
      </div>
      <div className='background-gradient'></div>
    </div>
  );
};
